import { RefObject, useEffect } from "react";

// Takes in a ref of an element, and assigns a specified callback that fires whenever
// a user clicks outside the element which the ref is tied to
export function useClickOutside(
  ref: RefObject<Element>,
  callback: (e: MouseEvent) => void
) {
  useEffect(() => {
    const handleClick = (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback(event);
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [ref, callback]);
}
